import moment from 'moment';
import { CompanyDataBodyRequest } from '~/services/banknow/types';
import Endpoints from '~/services/endpoints';
import { ApiMethod, httpRequest } from '~/services/httpRequest';
import Constants from '~/utils/constants';
type PersonType = 'fisica' | 'juridica';
export const generateSubmitBody = (
  form: CompanyDataBodyRequest,
  personType: PersonType,
  companyId?: string,
) => {
  if (!personType) {
    throw new Error('Informe um tipo de pessoa');
  }
  const userId = localStorage.getItem(Constants.USER_ID);
  const storedUser = localStorage.getItem(Constants.USER);
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userName = user?.nomeTitular || user?.nome || user?.nomeCompleto;
  const { companyData, bankData, responsiblesData } = form;
  const isAssociatedToGroup = !!companyData?.businessGroupInfoData
    ?.businessGroupData?.id;
  const usermetadataPayload = {
    userName,
    userId,
    origin: 'TEUCARD_BACKOFFICE',
  };
  const payloadFisica = {
    ...usermetadataPayload,
    companyData: {
      // endereço
      ...companyData,
      splitsModalities: isAssociatedToGroup
        ? null
        : companyData?.splitsModalities,
      addressZipCode: companyData?.addressZipCode?.unmasked,
      addressCountry: 'Brasil',

      phone: companyData?.phone?.unmasked,
      cnpj: companyData?.cnpj?.unmasked,
      category: companyData.category,
      brand: 'TEUCARD',
      ...(companyData?.generalParametersAgreement && {
        generalParametersAgreement: {
          invoiceDueDay:
            companyData?.generalParametersAgreement?.invoiceDueDay?.masked?.padStart(
              2,
              '0',
            ) || '',
          invoiceEmails: Array.isArray(
            companyData?.generalParametersAgreement?.invoiceEmails,
          )
            ? companyData?.generalParametersAgreement?.invoiceEmails
                .filter((i) => i?.value)
                .map((i) => i.value)
            : [],
        },
      }),
    },
    responsiblesData: [
      {
        name: companyData?.tradeName,
        email: companyData?.email,
        occupation: 'DONO',
        cpf: companyData?.cnpj?.unmasked,
        phone: companyData?.phone?.unmasked,
        dateOfBirth: moment(
          responsiblesData?.dateOfBirth?.masked,
          'DD/MM/YYYY',
        ).format('YYYY-MM-DD'),
        role: null,
      },
    ],
    ...(form?.bankData?.account &&
      !companyId && {
        bankData: [
          {
            ...bankData,
            type: 'CHECKING',
            accountHolder: {
              ...bankData?.accountHolder,
              cpfCnpj: bankData?.accountHolder?.cpfCnpj?.unmasked,
            },
          },
        ],
      }),
  };
  const payloadJuridica = {
    ...usermetadataPayload,
    companyData: {
      // endereço
      ...companyData,
      splitsModalities: isAssociatedToGroup
        ? null
        : companyData?.splitsModalities,
      addressZipCode: companyData?.addressZipCode?.unmasked,
      addressCountry: 'Brasil',

      phone: companyData?.phone?.unmasked,
      cnpj: companyData?.cnpj?.unmasked,
      category: companyData?.category,
      brand: 'TEUCARD',
      ...(companyData?.generalParametersAgreement && {
        generalParametersAgreement: {
          invoiceDueDay:
            companyData?.generalParametersAgreement?.invoiceDueDay?.masked?.padStart(
              2,
              '0',
            ) || '',
          invoiceEmails: Array.isArray(
            companyData?.generalParametersAgreement?.invoiceEmails,
          )
            ? companyData?.generalParametersAgreement?.invoiceEmails
                .filter((i) => i?.value)
                .map((i) => i.value)
            : [],
        },
      }),
    },
    responsiblesData: [
      {
        ...responsiblesData,
        surname: '',
        occupation: responsiblesData?.occupation,
        cpf: responsiblesData?.cpf?.unmasked,
        phone: responsiblesData?.phone?.unmasked,
        dateOfBirth: moment(
          responsiblesData?.dateOfBirth?.masked,
          'DD/MM/YYYY',
        ).format('YYYY-MM-DD'),
        role: null,
      },
    ],
    ...(form?.bankData?.account && {
      bankData: [
        {
          ...bankData,

          type: 'CHECKING',
          accountHolder: {
            ...bankData?.accountHolder,
            cpfCnpj: bankData?.accountHolder?.cpfCnpj?.unmasked,
          },
        },
      ],
    }),
  };

  return personType === 'fisica' ? payloadFisica : payloadJuridica;
};
export const fileToBase64 = async (f: Blob): Promise<string | ArrayBuffer> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(f);
    reader.onload = () => resolve(reader.result?.split(',')[1]);
    reader.onerror = (e) => reject(e);
  });
export const handleUpdateCompany = async (payload, id: string) => {
  const response = await httpRequest({
    url: Endpoints.companies.updateCompanyInterface,
    method: ApiMethod.PUT,
    reqParamsURL: { PARAM_ID: id },
    body: payload,
  });
  return response;
};
export const handleCreateCompany = async (payload) => {
  const response = await httpRequest({
    url: Endpoints.companies.createCompanyInterface,
    method: ApiMethod.POST,
    body: payload,
  });
  return response;
};
export const uploadPhotosOnEstabilishmentCreation = async (
  form: CompanyDataBodyRequest,
  companyId: string,
) => {
  if (!form?.newImages?.length || !companyId) return;
  const images = await Promise.all(
    form.newImages.map(async (f, index) => ({
      base64: await fileToBase64(f.file),
      filename: f.file.name,
      main: index === 0,
      mimetype: f.file.type,
      delete: false,
    })),
  );

  const response = await httpRequest({
    url: Endpoints.companies.putUploadCompanyImages,
    reqParamsURL: { PARAM_ID: companyId },
    body: { images: images },
    method: ApiMethod.PUT,
  });
  return response;
};
export const onSubmitEstabilishment = async (
  form: CompanyDataBodyRequest,
  personType: PersonType,
  companyId?: string,
) => {
  const payload = generateSubmitBody(form, personType, companyId);

  if (companyId) {
    const responseUpdate = await handleUpdateCompany(payload, companyId);
    return responseUpdate;
  }
  const responseCreate = await handleCreateCompany(payload);

  return responseCreate;
};
export interface GetCompaniesResponse {
  data: CompanyListResponse[];
  page: number;
  pageSize: number;
  totalPages: number;
  totalSize: number;
}

export interface CompanyListResponse {
  active: boolean;
  brand: string;
  document: string;
  email: string;
  id: string;
  name: string;
  partnership: string;
  phone: string;
  integrationId?: string;
}

export const getCompaniesHttp = async (params) => {
  const response = await httpRequest<GetCompaniesResponse>({
    url: Endpoints.companies.getCompanies,
    tryNewWay: true,
    body: {
      limite: 10,
      page: 1,
      ...params,
    },
    method: ApiMethod.GET,
  });
  return response;
};
interface ChangeCompanyStatusPayload {
  idParceiro: string;
  ativo: boolean;
  motivoAtivacaoInativacao: string;
  idUsuario: string;
  cnpj: string;
}

interface ChangeCompanyWhereAcceptedPayload {
  idParceiro: string;
  ondeAceita: boolean;
  motivoOndeAceita: string;
  idUsuario: string;
  cnpj: string;
}

export const changeCompanyStatus = async (
  payload: ChangeCompanyStatusPayload,
) => {
  const response = await httpRequest({
    url: Endpoints.companies.putChangeCompanyStatus,
    body: payload,
    method: ApiMethod.PUT,
  });
  return response;
};

export const changeCompanyWhereAccepted = async (
  payload: ChangeCompanyWhereAcceptedPayload,
) => {
  const response = await httpRequest({
    url: Endpoints.companies.putChangeCompanyWhereAccepted,
    body: payload,
    method: ApiMethod.PUT,
  });
  return response;
};
